import { z } from 'zod'

import { roleSchema } from '../roles'

export default z.object({
  __typename: z.literal('User').default('User'),
  id: z.string(),
  role: roleSchema,
})
